"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quantity = exports.isQuantityArray = exports.isQuantityJson = exports.isQuantityValue = exports.isQuantityUnitCandidate = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const isQuantityUnitCandidate = (whatever) => {
    return Boolean(whatever && typeof whatever === 'string');
};
exports.isQuantityUnitCandidate = isQuantityUnitCandidate;
const isQuantityValue = (whatever) => {
    return typeof whatever === 'number';
};
exports.isQuantityValue = isQuantityValue;
const isQuantityJson = (whatever) => {
    return Boolean(whatever &&
        typeof whatever === 'object' &&
        (0, exports.isQuantityValue)(whatever.Value) &&
        (0, exports.isQuantityUnitCandidate)(whatever.Unit));
};
exports.isQuantityJson = isQuantityJson;
const isQuantityArray = (whatever) => {
    return whatever.length === 2 && (0, exports.isQuantityValue)(whatever[0]) && (0, exports.isQuantityUnitCandidate)(whatever[1]);
};
exports.isQuantityArray = isQuantityArray;
class Quantity {
    // eslint-disable-next-line
    constructor(...args) {
        if ((0, exports.isQuantityJson)(args[0])) {
            this._quantity = args[0];
        }
        else if ((0, exports.isQuantityArray)(args)) {
            this._quantity = { Value: args[0], Unit: args[1] };
        }
        else {
            throw new Error(`Quantity.constructor() no valid quantity given`);
        }
    }
    setValueUnit(v, u) {
        this.value = v;
        this.unit = u;
    }
    get value() {
        return this._quantity.Value;
    }
    set value(v) {
        this._quantity.Value = v;
    }
    get unit() {
        return this._quantity.Unit;
    }
    set unit(u) {
        this._quantity.Unit = u;
    }
    get quantity() {
        return this._quantity;
    }
    fromJson(json) {
        this.unit = json.Unit;
        this.value = json.Value;
    }
    toJson() {
        return { Unit: this.unit, Value: this.value };
    }
    toString() {
        return `${this.value}${this.unit}`;
    }
    hasDefinedValue() {
        return echain_shared_ts_utils_1.NumberUtils.isDefinedNumber(this.value);
    }
}
exports.Quantity = Quantity;
//# sourceMappingURL=Quantity.js.map